import { COMMON_UI_I18N } from "@Front/Components/DesignSystem/helpers/commonUiI18n";

/** Contact e-mail line in UI / logs when the value is absent (notaire ou fiche liée). */
export function formatOptionalContactEmailForDisplay(email: string | null | undefined): string {
	const trimmed = email?.trim();
	if (trimmed) {
		return trimmed;
	}
	return COMMON_UI_I18N.folder.contactEmailNotProvidedShort;
}
